module.exports = __webpack_public_path__ + "img/flat_big.c74fbaec.jpg";